const Container = (props) => {
  const { children, style } = props;
  return (
    <div style={style} className="animated fadeIn">
      {children}
    </div>
  );
};

Container.propTypes = {};

Container.defaultProps = {};

export default Container;
